import axios from '@/assets/http';

export default {
    getSignContractInfo(params) {
        return axios.get(`/api/v3/frontend/onlineContract/getContractInfo`, {params: params});
    },
}
